/*these 9 values here are all of the possible result 
of subscriptionManagementStatus key for billing history api. */

export const MANAGEABLE = 'manageable';
export const UNMANAGEABLE_PAYMENT_TYPE = 'unmanageable_payment_type';
export const CONTRACT_PLAN = 'contract_plan';
export const IS_NOT_RENEWABLE = 'is_not_renewable';
export const PAUSED = 'paused';
export const REPLACEMENT = 'replacement';
export const RETIRED = 'retired';
export const CANCELLED = 'cancelled';
export const APPLIED_FOR_CANCELLATION = 'applied_for_cancellation';



// WEBPACK FOOTER //
// ./app/constants/subscriptionManagementStatus.js